<template>
	<div class="bg">
		<el-card class="content">
			<div class="content_cover"></div>
			<el-row>
				<div class="top" @click="close">✖</div>
			</el-row>
			<el-row type="flex" justify="center">
				<img src="../../assets/img/tips (1).png" alt="">
			</el-row>
			<div class="text_conter" style="margin:20px 0 50px 0">
				<div class="t1">您的场所信息审批不通过，请点击下方“修改”按钮</div>
				<div class="t1">再次提交等待审批</div>
				<div v-if="$store.getters.userInfo.note" class="t2">【原因】：{{ $store.getters.userInfo.note }}</div>
			</div>
			<el-divider></el-divider>
			<el-row type="flex" justify="center">
				<el-button class="go_out_btn" @click="close">退出系统</el-button>
				<el-button type="primary" class="revise_btn" @click="revise">修改</el-button>
			</el-row>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'ApprovalNoVue',
	data() {
		return {

		}
	},
	methods: {
		close() {
			this.$router.push('/login')
		},
		revise() {
			this.$router.push('/enterprise_information/set_enterprise')
		}
	}
}
</script>

<style lang="less" scoped>
.bg {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: url('../../assets/img/login_bg.png')
}

.content {
	position: relative;
	width: 640px;
	// height: 450px;
	border-radius: 10px;

	/deep/ .el-card__body {
		padding: 0;
	}
}



.content_cover {
	position: absolute;
	top: 0;
	left: 0;
	width: 640px;
	height: 145px;
	background: linear-gradient(0deg, rgba(255, 69, 95, 0) 0%, rgba(255, 69, 95, 0.1) 100%);
	border-radius: 10px;
}

.top {
	float: right;
	margin: 20px 23px 33px 0;
	width: 30px;
	height: 30px;
	border: 1px solid #787F82;
	border-radius: 50%;
	color: #787F82;
	text-align: center;
	line-height: 30px;
	// cursor
}

/deep/ .top:hover {
	cursor: pointer;
}

.go_out_btn {
	margin-right: 50px;
	margin-bottom: 20px;
	width: 214px;
	height: 50px;
	background: #FFFFFF;
	border: 1px solid #ACA9B4;
	border-radius: 6px;
}

.revise_btn {
	width: 214px;
	height: 50px;
	background: #6345D5;
	border-radius: 6px;
}

.text_conter {
	padding: 0 90px;
	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;
	font-size: 18px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #5D5951;

	div {
		margin: 5px 0;
	}

	.t1 {
		font-size: 20px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #5D5951;
		line-height: 36px;
	}

	.t2 {
		width: 480px;
		font-size: 16px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #5D5951;
	}
}
</style>